import React, { useState } from 'react'
import { Formik, Field } from 'formik'
import { useDispatch, useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { emailValidation, schema } from '../Layout/components/Footer/components/NewsletterForm/schema'
import { Button, Form } from 'lib/ui/components'
import { InterceptBlurEvent } from 'lib/ui/components/Form/types'
import { captureEmail } from 'modules/listrak'
import { EMPTY_STRING } from 'lib/core/resources/constants'
import { subscribe } from 'lib/core/data/customer/subscribe'
import { getSlice } from 'lib/core/data/customer/subscribe/selectors'

export const SubscribeForm = () => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const validateEmail = emailValidation(intl)
  const [error, setError] = useState(EMPTY_STRING)
  const [serviceError, setServiceError] = useState(EMPTY_STRING)
  const { isFetching, isSuccess } = useSelector(getSlice)
  const isSubscribed = isSuccess && !isFetching

  const handleSubmit = (values: Record<string, string>) => {
    const data = { ...values }
    const email = data?.email

    const subscribed = dispatch(subscribe(email))
    // @ts-expect-error // TODO: remove this ts-ignore.
    if (subscribed) {
      setServiceError(EMPTY_STRING)
    } else {
      setServiceError(intl.formatMessage({ id: 'app.whoops' }))
    }
    setError(EMPTY_STRING)
  }

  return (
    <>
      <Formik
        initialValues={schema}
        validationSchema={validateEmail}
        onSubmit={handleSubmit}
      >
        {() => {
          return (
            <Form.Wrapper>
              <Field
                name='email'
                component={Form.Input}
                isRequired
                placeholder='Enter your email'
                interceptBlur={(e: InterceptBlurEvent<string>) => {
                  captureEmail(e.value)
                }}
              />
              <Button
                type='submit'
                className={isSubscribed ? 'is-success' : EMPTY_STRING}
                isLoading={isFetching}
              >
                <>
                  {isSuccess ? (
                    <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
                      <path d='M21 6.285l-11.16 12.733-6.84-6.018 1.319-1.49 5.341 4.686 9.865-11.196 1.475 1.285z' />
                    </svg>
                  ) : (
                    <>
                      Sign Up
                    </>
                  )}
                </>
              </Button>
            </Form.Wrapper>
          )
        }}
      </Formik>
      {error && (
        <Form.Error>
          {error}
        </Form.Error>
      )}
      {serviceError && (
        <Form.Error>
          {serviceError}
        </Form.Error>
      )}
    </>
  )
}
